import { render, staticRenderFns } from "./LiveRanking.vue?vue&type=template&id=853b36c8&scoped=true"
import script from "./LiveRanking.vue?vue&type=script&lang=js"
export * from "./LiveRanking.vue?vue&type=script&lang=js"
import style0 from "./LiveRanking.vue?vue&type=style&index=0&id=853b36c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853b36c8",
  null
  
)

export default component.exports